import React, { useRef } from "react"
import { PortableText } from "@portabletext/react"
import { Link } from "gatsby"
import timImage from "../../../images/timImage.webp"
import { useAppContext } from "../../../context/appContext"
import "./lastSection.scss"
import { motion, useScroll, useTransform } from "framer-motion"

function LastSection({ data }) {
  const ref = useRef(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  })
  const backgroundY = useTransform(scrollYProgress, [0, 1], ["0%", "-25%"])
  // const textY = useTransform(scrollYProgress, [1, 0], ["-30%", "70%"])
  // const CardsY = useTransform(scrollYProgress, [1, 0], ["-30%", "70%"])
  // const opa = useTransform(scrollYProgress, [0, 0.3, 1], [0, 1, 1])

  const { setShowChatWindow } = useAppContext()

  const srelizerComponent = {
    marks: {
      link: ({ children, value }) => {
        const { blank, href } = value
        return blank ? (
          <a
            title={href}
            href={href}
            target="_blank"
            rel="noopener"
            // style={{ textDecoration: "underline" }}
          >
            {children}
          </a>
        ) : (
          <a href={href} title={href}>
            {children}
          </a>
        )
      },
      color: ({ children, value }) => {
        return <span style={{ color: value.color }}>{children}</span>
      },
    },
  }

  return (
    <div className="schedule-call-last-section" ref={ref}>
      {data?.content_image_desktop_view?.asset?.url && (
        <motion.img
          // src={data?.content_image_desktop_view?.asset?.url}
          src={data?.content_image_desktop_view?.asset?.url}
          alt="background image"
          style={{ y: backgroundY }}
          className="background-image"
        />
      )}
      <div className="section-content-wrapper">
        <motion.div
          whileInView={{ opacity: 1, y: 0 }}
          initial={false}
          animate={{ opacity: 0, y: 20 }}
          transition={{ type: "linear", delay: 0.15 }}
          className="section-header-wrapper"
        >
          <PortableText
            value={data?._rawNewSlideTitle}
            components={srelizerComponent as any}
          />
        </motion.div>
        <motion.div
          whileInView={{ opacity: 1, y: 0 }}
          initial={false}
          animate={{ opacity: 0, y: 30 }}
          transition={{ type: "spring", delay: 0.25, stiffness: 300 }}
          className="products-cta-wrapper"
        >
          {data?.cta_title && <p className="cta-title">{data?.cta_title}</p>}
          <Link
            to={data?.cta[0]?.cta_link}
            className="new-button-style-container"
          >
            <button className="button-50" role="button">
              {data?.cta[0]?.cta_name}
            </button>
          </Link>
        </motion.div>
      </div>
      <div
        className="tims-available-now"
        onClick={() => setShowChatWindow(true)}
      >
        <img src={timImage} alt="Tim image" className="tims-image" />
        <p>Tim's Available Now!</p>
      </div>
    </div>
  )
}

export default LastSection
